import { render, staticRenderFns } from "./CallUsages.vue?vue&type=template&id=0dbe28b1&scoped=true&"
import script from "./CallUsages.vue?vue&type=script&lang=js&"
export * from "./CallUsages.vue?vue&type=script&lang=js&"
import style0 from "./CallUsages.vue?vue&type=style&index=0&id=0dbe28b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbe28b1",
  null
  
)

export default component.exports